import { render } from "./common-problem.vue?vue&type=template&id=4a926480"
import script from "./common-problem.vue?vue&type=script&lang=js"
export * from "./common-problem.vue?vue&type=script&lang=js"

import "./common-problem.vue?vue&type=style&index=0&id=4a926480&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__